import { render, staticRenderFns } from "./BoxItemWrap.vue?vue&type=template&id=113c6f8a&scoped=true&"
import script from "./BoxItemWrap.vue?vue&type=script&lang=js&"
export * from "./BoxItemWrap.vue?vue&type=script&lang=js&"
import style0 from "./BoxItemWrap.vue?vue&type=style&index=0&id=113c6f8a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113c6f8a",
  null
  
)

export default component.exports